import { InjectionToken } from "@angular/core";
import { CityApiServiceConfig } from "./api-service-config.interface";

export const CITY_API_SERVICE_CONFIG_TOKEN = new InjectionToken<CityApiServiceConfig>(
  "CITY_API_SERVICE_CONFIG_TOKEN"
);


export const STATE = new InjectionToken<boolean>("STATE");
export const CITY = new InjectionToken<boolean>("CITY");

